var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableYellowEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#FFBB38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7611 15.6747L19.3246 16.2382L13.7753 21.7875H13.2118V21.224L18.7611 15.6747ZM20.9661 11.9875C20.8129 11.9875 20.6537 12.0487 20.5373 12.1651L19.4164 13.286L21.7133 15.5829L22.8342 14.462C23.0731 14.2231 23.0731 13.8372 22.8342 13.5984L21.4009 12.1651C21.2784 12.0426 21.1253 11.9875 20.9661 11.9875ZM18.7611 13.9414L11.9868 20.7156V23.0125H14.2837L21.0579 16.2382L18.7611 13.9414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableYellowEditIcon);
export default __webpack_public_path__ + "static/media/table-yellow-edit-icon.e73de5641cfd472097324a006b3bb8db.svg";
export { ForwardRef as ReactComponent };